import { render, staticRenderFns } from "./four.vue?vue&type=template&id=26b87212"
import script from "./four.vue?vue&type=script&lang=js"
export * from "./four.vue?vue&type=script&lang=js"
import style0 from "./four.vue?vue&type=style&index=0&id=26b87212&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports